<template>
  <div
    v-if="show && bannerNews.length > 0"
    class="flex sticky top-0 z-50 gap-x-3 px-8 py-2.5 w-full bg-red-800 sm:px-6"
  >
    <div class="flex overflow-hidden gap-x-6 justify-between items-center w-full min-w-0 sm:before:flex-1">
      <div
        v-for="news in bannerNews"
        :key="news.id"
        class="flex-grow w-auto text-sm font-semibold leading-6 text-white scroll-text"
      >
        <span class="mr-4"> [{{ news.title }}] {{ news.description }} </span>
      </div>
    </div>
    <div v-if="canDismiss" class="flex flex-1 flex-shrink justify-end items-center">
      <Button
        variant="ghost"
        class="hover:bg-transparent bg-transparent -m-3 p-3 focus-visible:outline-offset-[-4px]"
        @click="dismiss"
      >
        <span class="sr-only">Dismiss</span>
        <XMarkIcon class="w-5 h-5 text-white" aria-hidden="true" />
      </Button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { XMarkIcon } from "@heroicons/vue/20/solid";
import { useNewsStore } from "~~/stores/use-news-store";
import { storeToRefs } from "pinia";

defineProps<{
  canDismiss?: boolean;
}>();

const show = ref(true);

const newsStore = useNewsStore();
const { bannerNews } = storeToRefs(newsStore);

const dismiss = () => {
  show.value = false;
};
</script>
